export const emptyString = '';
export const threeDots = '...';
export const hyphen = '-';
export const dotSeparator = '•';
